import React from "react"
import { FieldError } from "react-hook-form"

import TextField, { TextFieldProps } from "@material-ui/core/TextField"
import { makeStyles } from "@material-ui/core/styles"

import withValidateController from "./withValidateController"

const useStyles = makeStyles({
    large: {
        "& input": {
            padding: "13px 15px",
            fontSize: "16px",
        },
    },
})

export type FormTextFieldProps = TextFieldProps & {
    fieldError?: FieldError
    labelDecorator?: React.ReactNode
    msg?: string
    large?: boolean
}

export default function FormTextField({
    msg,
    fieldError,
    large,
    className,
    ...rest
}: FormTextFieldProps) {
    const classes = useStyles()
    return (
        <TextField
            {...rest}
            className={`${className ?? ""} ${large ? classes.large : ""}`}
            variant="outlined"
            error={!!fieldError}
            helperText={fieldError?.message}
        />
    )
}

export const ValidatableFormTextField = withValidateController(FormTextField)
